<div class="message-result">
  @if (messageId) {
    <div class="message-result-header" (click)="toggleExpanded()">
      <span class="message-result-status" [class]="'status-' + status">
        @if (status === 'running') {
          Running…
        } @else if (status === 'completed') {
          Completed
        } @else if (status === 'timedOut') {
          Not completed
        } @else {
          Failed
        }
      </span>
      <span class="message-result-label">{{ displayLabel }}</span>
    </div>

    @if (expanded) {
      @if (loading) {
        <div class="message-result-loading">Loading…</div>
      } @else {
        @if (status === 'timedOut') {
          <div class="message-result-timeout">Command sent, not completed</div>
        }
        @if (progress?.error) {
          <div class="message-result-error">{{ progress.error }}</div>
        }
        @if (progress?.progressInfo?.exception) {
          <div class="message-result-error">{{ progress.progressInfo.exception }}</div>
        }
        @if (resultJson) {
          <pre class="message-result-json">{{ resultJson }}</pre>
        } @else if (status === 'completed') {
          <div class="message-result-empty">No result data</div>
        }
      }
    }
  }
</div>
